import { FC } from 'react';
import { Col, Row, Typography, Layout, Grid } from 'antd';
const { Link } = Typography;
const { Footer } = Layout;
const { useBreakpoint } = Grid;

interface FooterLayoutProps {
  mobileStyle?: React.CSSProperties;
  desktopStyle?: React.CSSProperties;
}

export const FooterLayout: FC<FooterLayoutProps> = (props) => {
  const screens = useBreakpoint();

  const SmallScreenFooter = () => {
    return (
      <Footer className="MyIntealth Service Catalog" style={{padding: '24px 18px 24px 18px', ...props.mobileStyle}}>
        <Row className="flex justify-center">
          <div>
            <Link
              href="https://www.intealth.org/terms/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3F4373"}}
            >
              Terms
            </Link>
            &nbsp;|&nbsp;
            <Link
              href="https://www.intealth.org/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3F4373"}}
            >
              Privacy
            </Link>
          </div>
          <br />
          <Typography.Text style={{textAlign:"center"}}>
            <sup>&reg;</sup> Registered in the US Patent and Trademark Office. <br /> Copyright &copy; 2025 by Intealth. All rights reserved.

          </Typography.Text>
        </Row>
      </Footer>
    );
  };

  const LargeScreenFooter = () => {
    return (
      <Footer className="mb-0">
        <Row
          style={{
            width: '100%',
            height: '100%',
            marginBottom: '10px',
            marginTop: '7px', 
            ...props.desktopStyle
          }}
        >
          <Col span={24} style={{ alignSelf: 'center' }}>
            <Link
              href="https://www.intealth.org/terms/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3F4373"}}
            >
              Terms
            </Link>
            &nbsp;|&nbsp;
            <Link
              href="https://www.intealth.org/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={{color: "#3F4373"}}
            >
              Privacy
            </Link>
            <br /> <sup>&reg;</sup> Registered in the US Patent and Trademark Office. <br /> Copyright &copy; 2025 by Intealth. All rights reserved.
          </Col>
        </Row>
      </Footer>
    );
  };
  return (
    <>
      {!screens.xs ? (
        <LargeScreenFooter />
      ) : (
        <SmallScreenFooter />
      )}
    </>
  );
};

